export const metricsNameText = {
  'Country': 'common_Country',
  'Region': 'common_Region',
  'Network type': 'common_netWork_Type',
  'Zone': 'common_Zone',
  'Os': 'common_System',
  'Lang': 'common_Language',
  'Return': 'return_return',
  'Retrun': 'return_return',
  'Register': 'ua_Register_chart',
  'CPA($)': 'ua_table_cpa',
  'LTV7': 'ua_LTV7',
  'New': 'engagement_register_New',
  'NEW': 'engagement_register_New',
  'Churn': 'engagement_churn_Churn',
  'DAU': 'engagement_active_activeUsers_day_au_title',
  'WAU': 'engagement_active_activeUsers_week_au_title',
  'MAU': 'engagement_active_activeUsers_month_au_title',
  'Mtx_revenue': 'pc_monetization_mtx_Rev',
  'Platform_revenue': 'pc_monetization_mtx_Rev_dl2',
  'Platform_mtx_revenue': 'pc_monetization_mtx_Rev_dl2',
  'Mtx_arpu': 'pc_monetization_mtx_arpu',
  'Mtx_arppu': 'pc_monetization_mtx_arppu',
  'Platform_arpu': 'pc_monetization_mtx_arpu_dl2',
  'Platform_arppu': 'pc_monetization_mtx_arppu_dl2',
  'Platform_mtx_arpu': 'pc_monetization_mtx_arpu_dl2',
  'Platform_mtx_arppu': 'pc_monetization_mtx_arppu_dl2',
  'Mtx_payers': 'pc_monetization_mtx_payer',
  'Mtx_payer_rate': 'pc_monetization_mtx_payer_rate',
  'Net_units': 'pc_console_revenue_net_units',
  'Net_revenue': 'pc_console_revenue_net_revenue',
  'Units_dlc_revenue': 'pc_monetization_revenue',
  'Platform_net_revenue': 'pc_monetization_revenue',
  'Units_net_revenue': 'pc_monetization_revenue',
  'Dlc_net_revenue': 'pc_monetization_revenue',
  'Units': 'pc_monetization_units',
  'Reactivated': 'nightingale_daily_reactivated',
  'Revenue': 'nightingale_daily_revenue',
  'Asp': 'nightingale_daily_asp$',
  'Refunds': 'nightingale_daily_refunds$',
  'Inflexion_revenue': 'pc_monetization_revenue',
  'Inflexion_new_churn': 'engagement_churn_Churn',
  'NEW_CHURN': 'engagement_churn_Churn',
  'UNITS': 'overview_area_units_table_header2',
  'PLATFORM_NET_REVENUE': 'overview_area_net_revenue_table_header2',
  'MTX_REVENUE': 'pc_monetization_mtx_Revenue($)',
  'INFLEXION_NEW_CHURN': 'engagement_churn_Churn',
  'WOW_PLAYER_ACT_NUM': 'wow_player_dau',
  'WOW_PLAYER_NEW_NUM': 'wow_player_new',
  'WOW_PLAYER_INV_NUM': 'wow_player_return',
  'WOW_AUTHOR_ACT_NUM': 'wow_creator_dau',
  'WOW_AUTHOR_NEW_NUM': 'wow_creator_new',
  'WOW_AUTHOR_INV_NUM': 'wow_creator_return',
  'GROSS_FULL_GAME_UNITS': 'pc_console_revenue_gross_base_game_units',
  'GROSS_REVENUE': 'pc_console_revenue_gross_revenue',

  
};
